import * as React from 'react'
import { Typography, Box } from '@mui/material'
import LoginForm from 'src/components/pages/login'
import useStyles from 'src/styles/pages/auth/signup'
import Link from 'next/link'
import { useRouter } from 'next/router'
import HeadTag from 'src/components/layout/head'
import { getCookie } from 'cookies-next'

const Login: React.FC = () => {
  const router = useRouter()
  const lang = getCookie('lang')

  React.useEffect(() => {
    const userToken: string | null =
      typeof window === 'object' ? localStorage.getItem('dtl_token') : null

    if (userToken) {
      if (JSON.parse(userToken).id) router.push('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { classes } = useStyles()
  return (
    <>
      <HeadTag
        title={
          lang === 'En'
            ? `Ditch The Label - Login`
            : ` Quítate las etiquetas - Ingresar`
        }
      />
      <div className={classes.root}>
        <Typography variant="h2" className={classes.header}>
          {lang === 'En' ? 'WELCOME' : 'BIENVENIDX'}
        </Typography>
        <LoginForm />
        <Typography variant="body2" className={classes.createLink}>
          {lang === 'En'
            ? 'NOT A DITCH THE LABEL MEMBER?'
            : '¿No eres miembro de Quítate las Etiquetas? '}{' '}
          <Link href="/auth/signup">
            {lang === 'En' ? 'CREATE AN ACCOUNT' : 'Crea una cuenta'}
          </Link>
        </Typography>
        <Box className={classes.bottomGradient}></Box>
      </div>
    </>
  )
}

export default Login
